import React from 'react';
import { BuildingOfficeIcon, BoltIcon, UserGroupIcon, ClipboardDocumentCheckIcon, StarIcon } from '@heroicons/react/24/outline';

const features = [
  {
    icon: BuildingOfficeIcon,
    title: 'Современные технологии',
    description: '4 экструзионные линии с современным оборудованием от ведущих мировых производителей',
    number: '01'
  },
  {
    icon: BoltIcon,
    title: 'Производственная мощность',
    description: 'Годовая производственная мощность 6000 тонн трубной продукции. Диаметр от 20 до 1200 мм',
    number: '02'
  },
  {
    icon: UserGroupIcon,
    title: 'Высококвалифицированный персонал',
    description: 'Высококвалифицированный инженерно-технический персонал с опытом работы более 15 лет',
    number: '03'
  },
  {
    icon: ClipboardDocumentCheckIcon,
    title: 'Системы менеджмента',
    description: 'Сертификаты систем менеджмента качества, экологического менеджмента и профессиональной безопасности',
    number: '04'
  }
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-secondary-50 dark:bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            <StarIcon className="h-5 w-5 mr-1" /> Преимущества работы с нами
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-secondary-900 dark:text-white mb-6">
            Почему выбирают <span className="text-primary-600">KazPolimerPlast</span>
          </h2>
          <p className="text-xl text-secondary-600 dark:text-secondary-300 max-w-3xl mx-auto">
            Опыт работы более 15 лет. Работаем с 2010 года. 
            Надежный партнер для ваших проектов.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group relative">
              <div className="bg-white dark:bg-secondary-800 rounded-2xl p-8 shadow-custom hover:shadow-card transition-all duration-300 transform hover:-translate-y-2 border border-secondary-100 dark:border-secondary-700">
                {/* Number Badge */}
                <div className="absolute -top-4 left-8">
                  <div className="w-8 h-8 bg-primary-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {feature.number}
                  </div>
                </div>
                
                {/* Icon */}
                <div className="w-16 h-16 bg-primary-50 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary-100 dark:group-hover:bg-primary-800/50 transition-colors">
                  <feature.icon className="h-8 w-8 text-primary-600" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-bold text-secondary-900 dark:text-white mb-4 group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
                  {feature.title}
                </h3>
                <p className="text-secondary-600 dark:text-secondary-300 leading-relaxed">
                  {feature.description}
                </p>
                
                {/* Hover Effect */}
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-primary-600 to-primary-700 opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">2010</div>
            <div className="text-secondary-600 text-sm sm:text-base">год основания</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">6000</div>
            <div className="text-secondary-600 text-sm sm:text-base">тонн в год</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">4</div>
            <div className="text-secondary-600 text-sm sm:text-base break-words">экструзионные линии</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">1200</div>
            <div className="text-secondary-600 text-sm sm:text-base break-words">макс. диаметр мм</div>
          </div>
          <div className="text-center">
            <div className="text-3xl sm:text-4xl font-bold text-primary-600 mb-2">15+</div>
            <div className="text-secondary-600 text-sm sm:text-base break-words">лет опыта</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;